import { render } from "./XCallback.vue?vue&type=template&id=5048e67e&scoped=true"
import script from "./XCallback.vue?vue&type=script&lang=js"
export * from "./XCallback.vue?vue&type=script&lang=js"

import "./XCallback.vue?vue&type=style&index=0&id=5048e67e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5048e67e"]])

export default __exports__